export default __webpack_public_path__ + "static/media/pnsv_stand_Transcooler.783104a0.png";